export const DEFAULT_PER_PAGE_OPTIONS = [10, 20, 50];
